import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAttributes, IAugmentedJQuery, IController, IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Debugger} from "debug";
import {Dialog} from "../../../../tjenester/Dialog";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";

const debug: Debugger = require('debug')('ÅrshjulskjemaKontroller');
const css = require('./årshjulinnslagskjema.scss');


export class ÅrshjulinnslagskjemaKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmGruppeAarshjulinnslagskjema', {
                bindings: {innslag: '<', vedEndring: '&', vedSlett: '&'},
                controller: ÅrshjulinnslagskjemaKontroller.forInjisering(),
                template: require('./årshjulinnslagskjema.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.ng.$attrs,
            regNavn.ng.$element,
            GruppeRessurs.regNavn,
            Dialog.regNavn,
            regNavn.gettext.gettextCatalog,
            ÅrshjulinnslagskjemaKontroller
        ];
    }

    innslag: RedigerÅrshjulinnslagModell; //settes via bindings/$onChanges
    vedEndring: (params:{innslag: RedigerÅrshjulinnslagModell})=>void; //settes via bindings/$onChanges
    vedSlett: (params:{innslag: RedigerÅrshjulinnslagModell})=>void; //settes via bindings/$onChanges

    slettefunksjonEksponert = false;

    constructor(private $attrs: IAttributes,
                private $element: IAugmentedJQuery,
                private gruppeRes: GruppeRessurs,
                private dialog: Dialog,
                private gettextCatalog: gettextCatalog) {
    }

    endring() {
        this.vedEndring({innslag: this.innslag});
    }

    slett() {
        this.innslag.slettet = true;

        //dersom all tekst er fjernet på en eksisterende tittel - reset til opprinnelig verdi
        if (this.innslag.spesifikasjon.id !== null && _.isEmpty(this.innslag.spesifikasjon.tittel))
            this.innslag.spesifikasjon.tittel = this.innslag.modell.tittel;

        this.vedSlett({innslag: this.innslag});
    }

    angreSletting() {
        this.innslag.slettet = false;
    }

    $onInit(): void {
        this.slettefunksjonEksponert = !_.isNil(this.$attrs['vedSlett']);
    }

    $onChanges(endringer: angular.IOnChangesObject): void {
        if (changesInneholder(endringer, 'innslag'))
            this.init();
    }

    // hjelpemetoder

    private init() {
    }

}

export class RedigerÅrshjulinnslagModell {
    spesifikasjon: l.ÅrshjulInnslagSpesifikasjon;
    modell: l.ÅrshjulInnslagModell;
    slettet = false;
    erSisteRad = false;

    static tomRedigerÅrshjulinnslagModell(uke = 1, gruppeId = null) {
        const modell = new RedigerÅrshjulinnslagModell({id: null, tittel: '', beskrivelse: '', startuke: uke, antallUker: 1, harForelder: false, gruppeId:gruppeId});
        return modell;
    }

    constructor(modell: l.ÅrshjulInnslagModell) {
        this.modell = modell;
        this.spesifikasjon = {id: this.modell.id, tittel: this.modell.tittel, beskrivelse: this.modell.beskrivelse, startuke: this.modell.startuke, antallUker: this.modell.antallUker};
    }
}
